import { awardsApi } from 'api'
import { AwardsAttachments } from 'types/AwardsAttachments'

// prettier-ignore
export const fetchAttachments = (slug: string) =>
  awardsApi.get<AwardsAttachments>(`/files/${slug}/attachments`)
